import React from 'react';
import ItemList from '../components/ItemList';

function Novedades() {

  const novedadesList = [
    { name: 'Sushi', description: 'Pieza Surimi, Salmón, Kebab', price: '1€ Pieza', img: "https://th.bing.com/th/id/R.a4d8f90c3de286bc75bfdf5ee75248be?rik=YHnsBv2cUuHC9w&pid=ImgRaw&r=0" },
    { name: 'Bocadillo Kebab', description: 'Kebab, queso, lechuga, patatas y salsa', price: '6,00€', img: "https://sultandonerkebab.es/wp-content/uploads/2022/07/SultanDonerKebab_23-1.jpg" },
   /*  { name: 'Alitas de Pollo', description: '', price: '4,00€', img: "https://thecookinglab.es/wp-content/uploads/2024/09/Alitas-de-pollo-en-freidora-de-aire-1.jpg" },
    { name: 'Nugget', description: '', price: '4,00€', img: "https://assets.tmecosys.com/image/upload/t_web767x639/img/recipe/ras/Assets/9D900DB3-435D-4AE4-9375-B152D2813750/Derivates/199C60FC-C264-43A3-B822-88AA5E50E954.jpg" },
    { name: 'Sandwich Gratinado', description: '', price: '5,00€', img: "https://www.cocinadelirante.com/sites/default/files/images/2022/08/como-hacer-sandwich-gratinado-gourmet.jpg" },
    */ { name: 'Sultán', description: 'Patatas gratinadas con kebab', price: '7,00€', img: "https://tb-static.uber.com/prod/image-proc/processed_images/f875c2e7b0666e16dfc2f29055a9b9f2/58f691da9eaef86b0b51f9b2c483fe63.jpeg" },
  ];





  return (


    <div id="paninis" className="container mx-auto mt-8 px-6">
      <h2 class="text-2xl font-bold text-gray-800 mb-4">Nuestro Menú</h2>
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

        {novedadesList.map((novedad, index) => (
          <ItemList
            key={index}
            name={novedad.name}
            description={novedad.description}
            price={novedad.price}
            img={novedad.img}
          />
        ))}
      </div>
    </div>
  );
}

export default Novedades;
